<template>
  <div class="tail-wrapper">
    <div class="content tail">
      <div class="flex_end nav">
        <div class="item">友情链接</div>
        <div
          v-for="(item, index) in linkList"
          :key="index"
          class="item"
          @click="link(item.link)"
        >
          {{ item.link_name }}
        </div>
      </div>
      <div class="text-center">
        <!-- 由
      <span class="company"> 湖北华中文化产权交易所 </span> 提供技术支持 -->
        <div>联系方式：<span class="company">027-88712327 88712336 </span></div>
        <div>E-mail：<span class="company">hbcprekf@163.com</span></div>
        <div>备案号：<span class="company">鄂ICP备16016530号-3 </span></div>
        <div>
          增值电信业务经营许可证：<span class="company">鄂B2-20180097</span>
        </div>
        <div style="flex: 0 0 39.3%">
          地址：<span class="company"
            >武汉市武昌区中山路374号湖北美术学院内1号教学楼2楼</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkList: [
        {
          name: "友情链接",
        },
        {
          name: "国家版权局",
        },
        {
          name: "湖北省广播电视局",
        },
        {
          name: "湖北省版权保护中心",
        },
        {
          name: "华中国家版权交易中心",
        },
      ],
    };
  },
  methods: {
    getLink() {
      this.$axios(this.$url + "/pc/userLogin/findFrilink").then((res) => {
        // console.log(res.data)
        let data = res.data;
        if (data.success) {
          this.linkList = data.r;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    link(link) {
      window.location.href = link;
    },
  },
  mounted() {
    this.getLink();
  },
};
</script>

<style lang='less' scoped>
.tail-wrapper{
  width: 100%;
}
.content {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
}
.tail-wrapper {
  overflow: hidden;
  width: 100%;
  background-color: #453e3e;
      min-width: 1440px;
}
.tail { 
  height: 176px;
  // background-color: #f2f2f2;
  background-color: transparent;
  padding-top: 8px;
  padding-bottom: 28px;
  box-sizing: border-box;
  z-index: 100;
  color: #ffffff;
  opacity: 0.69;
}
.item {
  cursor: pointer;
}
.nav {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  border-bottom: solid 1px #999999;
  // color: #666666;
  //  color: #666666;
  margin-bottom: 9px;
}
.text-center {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  // color: #666666;
  color: #ffffff;
  .company {
    font-size: 16px;
    // font-weight: normal;
    letter-spacing: 0px;
    // color:  #0068b7;
    color: #ffffff;
    // cursor: pointer;
  }
}
.text-center {
  display: flex;
  flex-wrap: wrap;
  div {
    flex: 0 0 33.3%;
    text-align: left;
  }
}

@media screen and (max-width: 1024px) {
  * {
    font-size: 12px;
  }

  .nav {
    font-size: 1rem;
  }
  .tail {
    padding: 0rem 1rem;
  }
  .text-center {
    display: block;
    div {
      display: inline-block;
    }
  }
  .text-center {
  }
  .text-center .company {
    font-size: 0.8rem;
  }
  .tail {
    height: 100%;
  }
  /deep/.content {
    background: #f2f2f2;
    background-color: #453e3e;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tail.vue